import { cn } from '@/lib/utils';
import type { CommunicationCue as CommunicationCueData } from '@shared/types/views';

interface CommunicationCueProps {
  cue: CommunicationCueData;
  className?: string;
}

/** An accent on the left, never a box: the cue lives inside its view's surface. */
const TONE_ACCENT: Record<CommunicationCueData['tone'], string> = {
  info: 'border-domino-aubergine',
  warning: 'border-[var(--domino-warning)]',
  success: 'border-[var(--domino-good)]',
};

export const CommunicationCue = ({ cue, className }: CommunicationCueProps) => (
  <div className={cn('border-l-2 pl-3', TONE_ACCENT[cue.tone], className)}>
    <p className="text-sm font-medium text-domino-ink">{cue.title}</p>
    <p className="mt-0.5 text-sm leading-6 text-domino-inkSoft">{cue.body}</p>
  </div>
);
